<template>
  <div id="mobile-search-tabs" class="mobile-search-tabs" role="tablist" aria-label="Mobiilin hakuvaihtoehdot">
    <button
      :class="`mobile-search-tabs__nav-item ${getTabClass(MOBILE_TABS.SEARCH)}`"
      @click="selectTab(MOBILE_TABS.SEARCH)"
      :aria-selected="props.selectedMobileTab === MOBILE_TABS.SEARCH"
      role="tab"
      tabindex="0"
      aria-label="Hae myytäviä asuntoja"
    >
      <i class="toggle-icon icon-search"></i>
    </button>
    <button
      :class="`mobile-search-tabs__nav-item ${getTabClass(MOBILE_TABS.LIST)}`"
      @click="selectTab(MOBILE_TABS.LIST)"
      :aria-selected="props.selectedMobileTab === MOBILE_TABS.LIST"
      role="tab"
      tabindex="0"
      aria-label="Lista myytävistä asunnoista"
    >
      <i class="toggle-icon icon-list"></i>
    </button>
    <button
      :class="`mobile-search-tabs__nav-item ${getTabClass(MOBILE_TABS.MAP)}`"
      @click="selectTab(MOBILE_TABS.MAP)"
      :aria-selected="props.selectedMobileTab === MOBILE_TABS.MAP"
      role="tab"
      tabindex="0"
      aria-label="Myytävät asunnot kartalla"
    >
      <i class="toggle-icon icon-map"></i>
    </button>
  </div>
</template>

<script setup lang="ts">
import config from '@/config';
import useEventBus from '@/app/composables/useEventBus';

const MOBILE_TABS = config.MOBILE_TABS;
const bus = useEventBus();

const props = defineProps<{
  selectedMobileTab: string;
}>();

function selectTab(tabName: string) {
  bus.$emit('search-selectedMobileTab', tabName);
}

function getTabClass(tabName: string) {
  return props.selectedMobileTab == tabName ? 'selected' : '';
}
</script>
